import { Layout } from '@/utils/routerHelper'
import { type RouteRecordRaw } from 'vue-router'

export interface IRouteMetaProps {
  iconClass: string;
  desc: string;
}

export const homeRouteRecordRaw: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/',
    name: 'Home',
    meta: {
      title: '首页'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/home/index.vue'),
        name: 'HomeIndex',
        meta: {
          title: '首页',
          icon: 'ep:home-filled',
          noCache: false,
          affix: true,
        },
      },
      // ================================================================== 活动
      // 路由匹配模式修改为  yyyy/活动名称
      {
        path: '/2026/newyear',
        component: () => import('@/views/activity/2026/newyear.vue'),
        name: 'HomeActivity2026Newyear',
        meta: {
          title: '视界焕新 新春特惠',
          hidden: true,
        },
      },
      {
        path: '/2026/labourday',
        component: () => import('@/views/activity/2026/newyear.vue'),
        name: 'HomeActivity2026Labourday',
        meta: {
          title: '劳动节特惠',
          hidden: true,
        },
      },
      {
        path: '/2026/july',
        component: () => import('@/views/activity/2026/julyspecial.vue'),
        name: 'Julyspecial',
        meta: {
          title: 'VR云览红色热土,数字传承百年初心',
          hidden: true,
        },
      },
      {
        path: '/2026/august',
        component: () => import('@/views/activity/2026/augustspecial.vue'),
        name: 'Augustspecial',
        meta: {
          title: 'VR云览红色热土,数字传承百年初心',
          hidden: true,
        },
      },
      {
        path: '/2026/september',
        component: () => import('@/views/activity/2026/septemberspecial.vue'),
        name: 'Septemberspecial',
        meta: {
          title: '金九银十，打造专属元宇宙数字空间',
          hidden: true,
        },
      },
      {
        path: '/2026/eleven',
        component: () => import('@/views/activity/2026/eleven.vue'),
        name: 'eleven',
        meta: {
          title: '双11嗨购季自研全景系统源码直降',
          hidden: true,
        },
      },
    ],
  },
  // ================================================================== 产品服务
  {
    path: '/product',
    component: Layout,
    redirect: '/product/pano',
    name: 'HomeProduct',
    meta: {
      title: '产品服务'
    },
    children: [
      {
        path: 'pano',
        component: () => import('@/views/project/pano/index.vue'),
        name: 'HomeProductPano',
        meta: {
          title: 'VR漫游(VR全景)互动工具',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'pano',
            desc: '全景图片/全景视频/高清平面图混合制作'
          },
        },
      },
      {
        path: '3dmodel',
        component: () => import('@/views/project/3dmodel/index.vue'),
        name: 'HomeProductModel',
        meta: {
          title: '3D模型互动工具',
          noCache: false,
          affix: true,
          props: {
            iconClass: '3dmodel',
            desc: '实时编辑与分享3D模型'
          },
        },
      },
      {
        path: 'copyright',
        component: () => import('@/views/project/copyright/index.vue'),
        name: 'HomeProductCopyright',
        meta: {
          title: '版权存证',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'copyright',
            desc: '区块链版权保护'
          },
        },
      },
      {
        path: 'bigpixels',
        component: () => import('@/views/project/bigpixels/index.vue'),
        name: 'HomeProductBigpixels',
        meta: {
          title: '大像素上传客户端',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'bigpixels',
            desc: '支持百亿大像素全景图快速切图上传'
          },
        },
      },
      {
        path: 'viewing',
        component: () => import('@/views/project/viewing/index.vue'),
        name: 'HomeProductViewing',
        meta: {
          title: 'VR带看系统',
          hidden: true,
          noCache: false,
          affix: true,
          props: {
            iconClass: 'shoot',
            desc: '实时连接，同屏带看，足不出户，边聊边看',
          },
        },
      },
      {
        path: 'mini-program',
        component: () => import('@/views/project/miniProgram/index.vue'),
        name: 'HomeProductMiniProgram',
        meta: {
          title: 'VR小程序系统',
          hidden: true,
          noCache: false,
          affix: true,
          props: {
            iconClass: 'collect',
            desc: '全景XR小程序，把全景装进口袋',
          },
        },
      },
      {
        path: 'xr-space',
        component: () => import('@/views/project/xrSpace/index.vue'),
        name: 'HomeProductXrSpace',
        meta: {
          title: 'XR大空间',
          hidden: true,
          noCache: false,
          affix: true,
          props: {
            iconClass: 'modeling',
            desc: 'VR沉浸探索大空间',
          },
        },
      },
      {
        path: 'video',
        component: () => import('@/views/project/video/index.vue'),
        name: 'HomeProductVideo',
        meta: {
          title: '全景视频',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'video',
            desc: '互动式全景视频内容与工具'
          },
        },
      },
      {
        path: 'live',
        component: () => import('@/views/project/live/index.vue'),
        name: 'HomeProductLive',
        meta: {
          title: 'VR直播',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'codeing',
            desc: '全域视频实时沉浸直播',
          },
        },
      },
      {
        path: 'ai-avatar',
        component: () => import('@/views/project/aiAvatar/index.vue'),
        name: 'HomeProductAiAvatar',
        meta: {
          title: 'AI数字人',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'video',
            desc: '输入文字，AI智能合成数字人',
          },
        },
      },
      {
        path: 'imgshop',
        component: () => import('@/views/project/imgshop/index.vue'),
        name: 'HomeProductImgshop',
        meta: {
          title: '图片市场',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'imgshop',
            desc: '图片版权自由交易平台'
          },
        },
      },
      {
        path: 'krpano',
        component: () => import('@/views/project/krpano/index.vue'),
        name: 'HomeProductKrpano',
        meta: {
          title: 'Krpano授权',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'copyright',
            desc: '轻松激活软件功能确保软件合规使用',
          },
        },
      },
      {
        path: 'soft',
        component: () => import('@/views/project/soft/index.vue'),
        name: 'HomeProductSoft',
        meta: {
          title: '软著登记',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'copyright',
            desc: '保护您的软件著作权确保软件质量',
          },
        },
      },
    ],
  },
  // ================================================================== 解决方案
  {
    path: '/solution',
    component: Layout,
    redirect: '/solution/travel',
    name: 'HomeSolution',
    meta: {
      title: '解决方案'
    },
    children: [
      {
        path: 'travel',
        component: () => import('@/views/solution/travel/index.vue'),
        name: 'HomeSolutionTravel',
        meta: {
          title: '智慧文旅',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'travel',
            desc: '漫步景区，身临其境'
          },
        },
      },
      {
        path: 'medical',
        component: () => import('@/views/solution/medical/index.vue'),
        name: 'HomeSolutionMedical',
        meta: {
          title: '智慧医疗',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'medical',
            desc: '院内导览预约流程一站式解决'
          },
        },
      },
      {
        path: 'education',
        component: () => import('@/views/solution/education/index.vue'),
        name: 'HomeSolutionEducation',
        meta: {
          title: '智慧教育',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'education',
            desc: '助力教育数字化升级'
          },
        },
      },
      {
        path: 'govparty',
        component: () => import('@/views/solution/govparty/index.vue'),
        name: 'HomeSolutionGovarty',
        meta: {
          title: '党建文化',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'govparty',
            desc: '沉浸体验, 感受党性初心'
          },
        },
      },
      {
        path: 'exhibition',
        component: () => import('@/views/solution/exhibition/index.vue'),
        name: 'HomeSolutionExhibition',
        meta: {
          title: '展厅展馆',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'exhibition',
            desc: '沉浸式体验互动展厅'
          },
        },
      },
      {
        path: 'factory',
        component: () => import('@/views/solution/factory/index.vue'),
        name: 'HomeSolutionFactory',
        meta: {
          title: '工厂园区',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'factory',
            desc: 'VR赋能工厂数字化升级'
          },
        },
      },
      {
        path: 'enterprise',
        component: () => import('@/views/solution/enterprise/index.vue'),
        name: 'HomeSolutionEnterprise',
        meta: {
          title: '数字政企',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'enterprise',
            desc: '可视化业务协同系统, 提高效率'
          },
        },
      },
      {
        path: 'house',
        component: () => import('@/views/solution/house/index.vue'),
        name: 'HomeSolutionHouse',
        meta: {
          title: 'VR看房',
          hidden: true,
          noCache: false,
          affix: true,
          props: {
            iconClass: 'travel',
            desc: 'VR小区/VR看房/VR楼书',
          },
        },
      },
      {
        path: 'relic',
        component: () => import('@/views/solution/relic/index.vue'),
        name: 'HomeSolutionRelic',
        meta: {
          title: '文物数字化',
          hidden: true,
          noCache: false,
          affix: true,
          props: {
            iconClass: 'travel',
            desc: 'VR文物数字化，让文化遗产“活起来”',
          },
        },
      },
      {
        path: 'campus',
        component: () => import('@/views/solution/campus/index.vue'),
        name: 'HomeSolutionCampus',
        meta: {
          title: 'VR校园',
          hidden: true,
          noCache: false,
          affix: true,
          props: {
            iconClass: 'education',
            desc: 'VR校园/云招生/云教学',
          },
        },
      },
    ],
  },
  // ================================================================== 内容社区
  {
    path: '/galleries',
    component: Layout,
    redirect: '/galleries',
    name: 'HomeGalleries',
    meta: {
      title: '内容社区'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/community/content/index.vue'),
        name: 'HomeGalleriesContent',
        meta: {
          title: '内容社区',
          noCache: false,
          affix: true,
        },
      },
    ],
  },
  // ================================================================== 定制服务
  {
    path: '/services',
    component: Layout,
    redirect: '/services/shoot',
    name: 'HomeServices',
    meta: {
      title: '定制服务'
    },
    children: [
      {
        path: 'shoot',
        component: () => import('@/views/serve/shoot/index.vue'),
        name: 'HomeServicesShoot',
        meta: {
          title: '全景拍摄服务',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'shoot',
            desc: '从地面到高空：全景维度下的细节深挖与宏观呈现'
          },
        },
      },
      {
        path: 'collect',
        component: () => import('@/views/serve/collect/index.vue'),
        name: 'HomeServicesCollect',
        meta: {
          title: '实景空间三维采集服务',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'collect',
            desc: '激光扫描仪空间扫描，制作3D空间漫游作品'
          },
        },
      },
      {
        path: 'modeling',
        component: () => import('@/views/serve/modeling/index.vue'),
        name: 'HomeServicesModeling',
        meta: {
          title: '3D建模服务',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'modeling',
            desc: '为你提供全场景使用需求解决方案'
          },
        },
      },
      {
        path: 'codeing',
        component: () => import('@/views/serve/codeing/index.vue'),
        name: 'HomeServicesCodeing',
        meta: {
          title: '功能定制化开发',
          noCache: false,
          affix: true,
          props: {
            iconClass: 'codeing',
            desc: '提供定制化服务，制作空间漫游系统功能定制开发'
          },
        },
      },

    ],
  },
  // ================================================================== 商城
  {
    path: '/shop',
    component: Layout,
    redirect: '/shop',
    name: 'HomeShop',
    meta: {
      title: '商城'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/shop/index.vue'),
        name: 'HomeShopIndex',
        meta: {
          title: '商城',
          noCache: false,
          affix: true,
        },
      },
      {
        path: 'detail',
        component: () => import('@/views/shop/detail.vue'),
        name: 'ShopDetail',
        meta: {
          title: '商品详情',
          hidden: true,
          noCache: true,
        },
      },
      {
        path: 'list',
        component: () => import('@/views/shop/list.vue'),
        name: 'ShopList',
        meta: {
          title: '全部商品',
          hidden: true,
          noCache: true,
        },
      },
      {
        path: 'order',
        component: () => import('@/views/shop/order.vue'),
        name: 'ShopOrder',
        meta: {
          title: '订单详情',
          hidden: true,
          noCache: true,
        },
      },
    ],
  },
]

export const noticeRecordRaw: RouteRecordRaw[] = [
  {
    path: '/notice',
    redirect: '/notice',
    component: Layout,
    name: 'HomeNotice',
    meta: {
      title: '内容社区'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/community/agreement/index.vue'),
        name: 'HomeNoticeAgreement',
        meta: {
          title: '协议',
        },
      }
    ],
  },
]

export const vipRouteRecordRaw: RouteRecordRaw[] = [
  {
    path: '/vip',
    component: Layout,
    redirect: '/vip',
    name: 'HomeVip',
    meta: {
      title: '会员中心'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/vip/index.vue'),
        name: 'HomeVipIndex',
        meta: {
          title: '会员中心',
        },
      }
    ],
  },
]